import * as React from 'react';
import { AnalyticsTrigger } from '@core-front/analytics';
import { useLabels } from '@core-front/label-provider';
import PropsChecker from '@core-front/props-checker';
const Toggle = (props) => {
    return (React.createElement(PropsChecker, { componentName: "Toggle", componentProps: props, defaultValueName: "defaultChecked", valueName: "checked", onChangeNames: "onChange", isComponentDisabled: props.disabled || props.loading },
        React.createElement(AnalyticsTrigger, { trigger: {
                callback: 'onChange',
                id: ([checked]) => `Toggle - ${checked ? 'ON' : 'OFF'} - ${props.id}`,
                elementType: 'toggle',
                elementId: props.id,
                interactionType: ([checked]) => `${checked ? 'select' : 'deselect'}`,
            } },
            React.createElement(ToggleInner, Object.assign({}, props)))));
};
export const ToggleInner = (props) => {
    const { label, onLabel, input, id, labelPosition = 'right', className, size, onChange, checked, defaultChecked, disabled, children, components, loading, loadingLabel, required, employee, } = props;
    const labels = useLabels();
    const [innerChecked, setInnerChecked] = React.useState(defaultChecked || false);
    const isChecked = onChange && typeof checked !== 'undefined' ? checked : innerChecked;
    const handleChange = () => {
        const nextChecked = !isChecked;
        if (disabled || loading) {
            return;
        }
        if (typeof checked === 'undefined') {
            setInnerChecked(nextChecked);
        }
        if (onChange) {
            onChange(nextChecked);
        }
    };
    const getLabels = (positions) => {
        const isCurrent = positions.includes(labelPosition);
        const { Spinner } = components;
        if (!isCurrent) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "toggle__text toggle__text--off", "aria-hidden": !children }, children || label),
            onLabel && (React.createElement("span", { className: "toggle__text toggle__text--on", "aria-hidden": !children }, children || onLabel)),
            loading && React.createElement(Spinner, { className: "toggle__text toggle__text--loading" })));
    };
    const getSRLabel = () => {
        if (loading) {
            return loadingLabel || labels.get('loading');
        }
        return isChecked && onLabel ? onLabel : label;
    };
    function BEM() {
        const classArray = ['toggle'];
        if (size) {
            classArray.push('toggle--' + size);
        }
        if (onLabel) {
            classArray.push('toggle--with-on-label');
        }
        if (loading) {
            classArray.push('toggle--loading');
        }
        if (employee) {
            classArray.push('toggle--employee');
        }
        classArray.push(`toggle--with-label-${labelPosition}`);
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    function inputBEM() {
        const classArray = ['toggle__input'];
        if (input && input.className) {
            classArray.push(input.className);
        }
        return classArray.join(' ');
    }
    return (React.createElement("div", { className: BEM(), 
        // Prevent click events from propagating to parents
        onClick: e => e.stopPropagation() },
        React.createElement("input", Object.assign({}, input, { type: "checkbox", id: id, className: inputBEM(), onChange: handleChange, checked: isChecked, defaultChecked: undefined, disabled: disabled || loading, "aria-required": required })),
        React.createElement("label", { htmlFor: id, className: "toggle__label" }, getSRLabel()),
        React.createElement("span", { className: "toggle__inner", onClick: handleChange },
            React.createElement("span", { className: "toggle__indicator" }, getLabels(['inside'])),
            React.createElement("span", { className: "toggle__label-wrapper" }, getLabels(['right', 'left'])))));
};
export { Toggle as default };
